import { useLocation } from 'react-router-dom';

import { DepositStep } from '../constants';
import {
  URL_PREPARE,
  URL_REDIRECT,
  URL_PROCESS_RESULT
} from './constants';
import { ParseUrlResult } from './types';

function useParseUrl(): ParseUrlResult {
  const { pathname } = useLocation();

  if (pathname.includes(URL_REDIRECT)) {
    const redirectUrlStartIndex = pathname.indexOf(URL_REDIRECT);
    const [status, transactionId] = pathname.slice(redirectUrlStartIndex + URL_REDIRECT.length).replace('/', '').split('/')

    return {
      stepStart: DepositStep.StartRedirect,
      transactionId,
      success: status === 'success'
    };
  }

  if (pathname.includes(URL_PREPARE)) {
    return {
      stepStart: DepositStep.StartPrepare,
      transactionId: getTransactionId(pathname, URL_PREPARE)
    };
  }

  if (pathname.includes(URL_PROCESS_RESULT)) {
    return {
      stepStart: DepositStep.StartParseResultRedirect,
      transactionId: getTransactionId(pathname, URL_PROCESS_RESULT)
    };
  }

  return { transactionId: '', stepStart: DepositStep.Error };
}

function getTransactionId(pathname: string, url: string) {
  const startIndex = pathname.indexOf(url);
  return pathname.slice(startIndex + url.length).replace('/', '');
}

export default useParseUrl;
